import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';

interface PracticeAreaCTAProps {
  title: string;
  landingPageUrl: string;
}

const PracticeAreaCTA: React.FC<PracticeAreaCTAProps> = ({ title, landingPageUrl }) => {
  return (
    <div className="mt-6 p-6 bg-accent/10 border-l-4 border-accent rounded-r-lg">
      <p className="text-lg text-gray-800 mb-4">
        Ønsker du mer informasjon om våre tjenester innen {title.toLowerCase()}?
      </p>
      <Link to={landingPageUrl}>
        <Button size="md">
          Se våre tjenester innen {title} →
        </Button>
      </Link>
    </div>
  );
};

export default PracticeAreaCTA;
